// src/components/dashboard/tiles/MLBPlayerNewsTile.js
import React, { useState, useEffect } from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { mlbAPI } from '../../../services/apiService';
import PlayerLink from '../../PlayerLink';

const MLBPlayerNewsTile = ({ leagueId }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await mlbAPI.getPlayerNotes();
        setNews(Array.isArray(result) ? result : []);
      } catch (e) {
        setNews([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className={`${dynastyTheme.components.card.base} p-6`}>
      <h3 className={`text-lg font-bold ${dynastyTheme.classes.text.white} mb-4`}>
        MLB Player News
      </h3>
      {loading ? (
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin" />
          <span className={`text-sm ${dynastyTheme.classes.text.neutralLight}`}>Loading news...</span>
        </div>
      ) : news.length === 0 ? (
        <p className={`text-sm ${dynastyTheme.classes.text.neutralLight}`}>No recent player news.</p>
      ) : (
        <div className="space-y-3 max-h-80 overflow-y-auto">
          {news.slice(0, 10).map((item, i) => (
            <div key={i} className={`flex gap-3 border-b ${dynastyTheme.classes.border.neutral} pb-3 last:border-0`}>
              <div className={`w-1 rounded-full flex-shrink-0 ${item.note_type === 'injury' ? 'bg-red-500' : 'bg-blue-500'}`} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <PlayerLink mlbId={item.player_id || null} name={item.player_name} style={{ fontSize: '0.875rem', fontWeight: 600, color: '#ffffff' }} />
                  {item.note_type === 'injury' && (
                    <span className="text-xs px-1.5 py-0.5 rounded bg-red-500/20 text-red-400 border border-red-500/30 font-medium">
                      Injury
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-300 leading-relaxed line-clamp-3">
                  {item.content}
                </p>
                <div className="text-sm text-gray-400 mt-1.5">
                  {item.date ? new Date(item.date).toLocaleDateString() : ''}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MLBPlayerNewsTile;
